import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  EventEmitter, HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AccountModel} from "../../models/account.model";

require('./demand-account-table.scss');
@Component({
  standalone: false,
  selector: 'app-demand-account-table',
  templateUrl: './demand-account-table.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandAccountTableComponent implements OnChanges, AfterViewInit {

  @Input() accounts: AccountModel[];
  @Input() isLoading: boolean;
  @Input() isInitialized: boolean;

  @Output() reloadEvent = new EventEmitter<any>();
  @Output() selectAccount = new EventEmitter<AccountModel>();
  @Output() fetchNextEvent = new EventEmitter<null>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public isScrollable: boolean;
  public displayAsItems: boolean;
  public readonly skeletonRows: undefined[] = Array.from({length: 10});

  constructor() {
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.displayAsItems = window.innerWidth < 600;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.accounts) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }

  ngAfterViewInit(): void {
    if (!this.displayAsItems) {
      const div1 = document.getElementById('header');
      const div2 = document.querySelectorAll('.cdk-virtual-scroll-viewport')[0];


      div2.addEventListener('scroll', e => {
        div1.scrollTop = div2.scrollTop;
        div1.scrollLeft = div2.scrollLeft;
      })
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }

  onSelectAccount(account: AccountModel) {
    this.selectAccount.emit(account);
  }

}
